const wrapLongText: { [key: string]: string } = {
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  whiteSpace: 'normal'
};

export const style: { [key: string]: { [key: string]: string } } = {
  primaryTitle: {
    fontWeight: 'bold',
    fontSize: '14pt',
    margin: '0px',
    ...wrapLongText
  },
  secondaryTitle: {
    fontWeight: 'bold',
    fontSize: '10pt',
    ...wrapLongText
  },
  subtitle: { fontWeight: 'normal', fontSize: '10pt', color: '#616365', ...wrapLongText },
  numberFormattingThousandsLabel: { fontWeight: 'normal', fontSize: '10pt', color: '#616365', display: 'block' }
};
